import '../styles/main.css'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom';

export default function Main() {
    
    return(
        <>
        <Header />
        <div id="main">
            <div id="content-wrapper">
                <div id="text-content">
                    <h1>Tailored Solutions. <br/>Trusted Advocacy.</h1>
                    <p>When results matter, you can rely on our dedication, precision, and unwavering commitment to excellence.</p>
                    <Link to="/contact-us"><button id="button">CONTACT US</button></Link>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
}